import { globalAxios } from "@/axios-path.js";
export default {
    namespaced: true,
    state: {
        storeOptionList: [],
        storeOptionV1List: []
    },
    mutations: {
        SET_OPTION_LIST(state, list) {
            state.storeOptionList = list;
        },
        UPDATE_OPTION_ITEM(state, item, option_id) {
            let index = state.storeOptionList.findIndex((element) => element.option_id == option_id);
            state.storeOptionList.splice(index, 1, item);
        },
        ADD_OPTION_ITEM(state, item) {
            state.storeOptionList.push(item);
        },
        SET_V1_OPTION_LIST(state, list) {
            state.storeOptionV1List = list;
        },
        REMOVE_OPTION_ITEM(state, option_id) {
            let index = state.storeOptionList.findIndex((element) => element.option_id == option_id);
            state.storeOptionList.splice(index, 1);
        }
    },
    actions: {
        async FETCH_OPTION_LIST({ commit, dispatch, }, { store_id, province }) {
            let url = `/api/v1/${province}/merChant/bof_get_option_choice?store_id=${store_id}`;
            try {
                let res = await globalAxios.get(url);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return false;
                } else {
                    commit("SET_OPTION_LIST", res.data);
                    return true;
                }
            } catch (error) {
                return false;
            }
        },
        async FETCH_V1_OPTION_LIST({ commit, dispatch, }, { store_id, province }) {
            let url = `/api/v1/${province}/merChant/bof_get_old_option_choice?store_id=${store_id}`;
            try {
                let res = await globalAxios.get(url);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return false;
                } else {
                    commit("SET_V1_OPTION_LIST", res.data);
                    return true;
                }
            } catch (error) {
                return false;
            }
        },
        async EDIT_OPTION_ITEM({ commit, dispatch, }, { form, province }) {
            for (let val of form.option_choice) {
                if (val.choice_id == null) {
                    delete val.choice_id;
                }
            }
            let url = `/api/v1/${province}/merChant/bof_update_option_choice`;
            try {
                let res = await globalAxios.put(url, form);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return false;
                } else {
                    commit("UPDATE_OPTION_ITEM", res.data);
                    return true;
                }
            } catch (error) {
                return false;
            }
        },
        async CREATE_OPTION_ITEM({ commit, dispatch, }, { form, province }) {
            delete form.option_id;
            for (let val of form.option_choice) {
                delete val.choice_id;
            }
            let url = `/api/v1/${province}/merChant/bof_create_option_choice`;
            try {
                let res = await globalAxios.post(url, form);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return false;
                } else {
                    commit("ADD_OPTION_ITEM", res.data);
                    return true;
                }
            } catch (error) {
                return false;
            }
        },
        async DELETE_OPTION_ITEM({ commit, dispatch, }, { option_id, province }) {
            let url = `/api/v1/${province}/merChant/bof_delete_option_choice/${option_id}`;
            try {
                let res = await globalAxios.delete(url);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return false;
                } else {
                    commit("REMOVE_OPTION_ITEM", res.data);
                    return true;
                }
            } catch (error) {
                return false;
            }
        },
        async TRANSFER_V1_OPTION(payload) {

        }
    },
    getters: {

    }
};
